export default __webpack_public_path__ + "static/media/water_can.71624475.jpg";